'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = numberDecimals;

var _numberIsFinite = require('./numberIsFinite');

var _numberIsFinite2 = _interopRequireDefault(_numberIsFinite);

var _isInteger = require('./isInteger');

var _isInteger2 = _interopRequireDefault(_isInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the number of decimal places in a number
 *
 * @param {Number} number The number to be checked
 * @returns {Number} The number of decimal places in the given number
 */
function numberDecimals(number) {
    var abs = Math.abs(number);
    var tmp = abs;
    var count = 1;

    while (!(0, _isInteger2.default)(tmp) && (0, _numberIsFinite2.default)(tmp)) {
        tmp = abs * Math.pow(10, count++);
    }

    return count - 1;
}
//# sourceMappingURL=numberDecimals.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/numberDecimals.js
 ** module id = 232
 ** module chunks = 0 1
 **/